// src/pages/salary_Final/components/Mo3tiCard.jsx

const Mo3tiCard = ({ title, icon: Icon, theme, isRTL, children }) => {
  const isDark = theme === "dark";

  const cardStyle = {
    background: isDark ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
    WebkitBackdropFilter: isDark ? "blur(25px) saturate(180%)" : "blur(10px)",
    border: isDark ? "1px solid rgba(255,255,255,0.15)" : "1px solid rgba(0,0,0,0.05)",
    borderRadius: "clamp(12px, 2vw, 28px)",
    padding: "clamp(16px, 2.5vw, 28px)",
    boxShadow: "none",
    marginBottom: "clamp(16px, 2vw, 24px)",
    transition: "all 0.3s ease",
    cursor: "pointer",
    direction: isRTL ? "rtl" : "ltr",
  };

  const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  };

  const titleRowStyle = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    direction: isRTL ? "rtl" : "ltr",
  };

  const titleStyle = {
    color: isDark ? "#ffffff" : "#0f172a",
    fontSize: "clamp(16px, 3vw, 20px)",
    fontWeight: "700",
    margin: 0,
  };

  return (
    <div style={cardStyle} className="hover-card">
      <div style={headerStyle}>
        <div style={titleRowStyle}>
          {Icon && <Icon size={24} color="#2e7cba" />}
          <h2 style={titleStyle}>{title}</h2>
        </div>
      </div>
      {children}
    </div>
  );
};

export default Mo3tiCard;
